<div
  class="fdi-wrapper"
  *ngIf="visible">
  <!-- Header -->
  <div class="fdi-header">
    <span class="fdi-icon">⬡</span>
    <span class="fdi-title">Form Debug Inspector</span>
    <span
      class="fdi-badge"
      [class.fdi-badge--valid]="isFormValid"
      [class.fdi-badge--invalid]="!isFormValid">
      {{ isFormValid ? 'VALID' : 'INVALID' }}
    </span>
    <div class="fdi-header-stats">
      <span class="fdi-stat fdi-stat--valid">{{ validCount }} valid</span>
      <span class="fdi-sep">·</span>
      <span class="fdi-stat fdi-stat--invalid">{{ invalidCount }} invalid</span>
      <span class="fdi-sep">·</span>
      <span class="fdi-stat fdi-stat--disabled">{{ disabledCount }} disabled</span>
    </div>
    <div class="fdi-legend">
      <span class="fdi-legend-item">
        <span class="fdi-type-badge fdi-type--control">C</span>control
      </span>
      <span class="fdi-legend-item">
        <span class="fdi-type-badge fdi-type--group">G</span>group
      </span>
      <span class="fdi-legend-item">
        <span class="fdi-type-badge fdi-type--array">A</span>array
      </span>
    </div>
  </div>

  <!-- Body -->
  <div class="fdi-body">
    <!-- LEFT: tabella controls -->
    <div class="fdi-panel fdi-panel--table">
      <div class="fdi-panel-label">
        CONTROLS
        <span class="fdi-count">{{ allControls.length }}</span>
      </div>

      <div class="fdi-table-scroll">
        <table class="fdi-table">
          <thead>
            <tr>
              <th class="th-type"></th>
              <th class="th-path">Path</th>
              <th class="th-value">Value</th>
              <th class="th-state">State</th>
              <th class="th-disabled">Disabled</th>
              <th class="th-errors">Errors</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let f of allControls"
              class="fdi-row"
              [class.fdi-row--valid]="f.valid && !f.disabled"
              [class.fdi-row--invalid]="!f.valid && !f.disabled"
              [class.fdi-row--disabled]="f.disabled"
              [class.fdi-row--node]="f.controlType !== 'control'">
              <!-- Tipo -->
              <td class="fdi-cell fdi-cell--type">
                <span
                  class="fdi-type-badge"
                  [class.fdi-type--control]="f.controlType === 'control'"
                  [class.fdi-type--group]="f.controlType === 'group'"
                  [class.fdi-type--array]="f.controlType === 'array'">
                  {{ f.controlType === 'control' ? 'C' : f.controlType === 'group' ? 'G' : 'A' }}
                </span>
              </td>

              <!-- Path con indentazione visiva -->
              <td class="fdi-cell fdi-cell--key">
                <span
                  class="fdi-indent"
                  [style.width.px]="f.depth * 14"></span>
                <span
                  class="fdi-tree-branch"
                  *ngIf="f.depth > 0"
                  >└</span
                >
                <span
                  class="fdi-dot"
                  [class.fdi-dot--valid]="f.valid && !f.disabled"
                  [class.fdi-dot--invalid]="!f.valid && !f.disabled"
                  [class.fdi-dot--disabled]="f.disabled">
                </span>
                <span
                  class="fdi-path"
                  [class.fdi-path--leaf]="f.controlType === 'control'"
                  [class.fdi-path--node]="f.controlType !== 'control'"
                  [title]="f.path">
                  {{ getLastSegment(f.path) }}
                </span>
                <!-- Full path in tooltip su hover, mostralo anche inline se depth=0 -->
                <span
                  class="fdi-full-path"
                  *ngIf="f.depth > 0"
                  [title]="f.path">
                  {{ f.path }}
                </span>
              </td>

              <!-- Valore -->
              <td class="fdi-cell fdi-cell--value">
                <ng-container *ngIf="f.controlType === 'control'; else containerVal">
                  <span
                    class="fdi-value"
                    [class.fdi-value--null]="
                      f.value === null || f.value === undefined || f.value === ''
                    ">
                    {{ formatValue(f.value) }}
                  </span>
                </ng-container>
                <ng-template #containerVal>
                  <span class="fdi-value fdi-value--meta">
                    {{
                      f.controlType === 'array'
                        ? '[' + getArrayLength(f.value) + ' items]'
                        : '{object}'
                    }}
                  </span>
                </ng-template>
              </td>

              <!-- State -->
              <td class="fdi-cell fdi-cell--state">
                <ng-container *ngIf="!f.disabled">
                  <span
                    class="fdi-status"
                    [class.fdi-status--valid]="f.valid"
                    [class.fdi-status--invalid]="!f.valid">
                    {{ f.valid ? '✓' : '✗' }}
                  </span>
                </ng-container>
                <span
                  *ngIf="f.dirty"
                  class="fdi-tag"
                  >dirty</span
                >
                <span
                  *ngIf="f.touched"
                  class="fdi-tag"
                  >touched</span
                >
              </td>

              <!-- Disabled -->
              <td class="fdi-cell fdi-cell--disabled">
                <span
                  *ngIf="f.disabled"
                  class="fdi-dis-badge fdi-dis--self"
                  >⊘ self</span
                >
                <span
                  *ngIf="!f.disabled && f.hasDisabledChild"
                  class="fdi-dis-badge fdi-dis--child"
                  >◌ children</span
                >
                <span
                  *ngIf="!f.disabled && !f.hasDisabledChild"
                  class="fdi-dash"
                  >—</span
                >
              </td>

              <!-- Errors -->
              <td class="fdi-cell fdi-cell--errors">
                <span
                  class="fdi-error-pill"
                  *ngFor="let e of getErrorKeys(f.errors)"
                  >{{ e }}</span
                >
                <span
                  *ngIf="!f.errors"
                  class="fdi-dash"
                  >—</span
                >
              </td>
            </tr>

            <tr *ngIf="allControls.length === 0">
              <td
                colspan="6"
                class="fdi-empty">
                No controls detected
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- RIGHT: JSON viewer -->
    <div class="fdi-panel fdi-panel--json">
      <div class="fdi-panel-label">
        FORM VALUE
        <span class="fdi-json-label">JSON</span>
      </div>
      <div class="fdi-json-scroll">
        <pre
          class="fdi-json"
          [innerHTML]="formattedJson"></pre>
      </div>
    </div>
  </div>
</div>
